import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/stages`, {params: {...filter}})
  },

  create(stage){
    return Http.post(`/stages`, {stage: {
      ...stage,
    }})
  },

  update(stage){
    return Http.put(`/stages/${stage.id}`, {
      stage: {
        ...stage,
      },
    });
  },

  show(id) {
    return Http.get(`/stages/${id}`);
  },

  delete(){
    // return Http.delete(`/action_plans/${id}`)
  }

}
